import GalleryTopLeftContainer from './galleryTopLeftContainer'
export default GalleryTopLeftContainer
